module.exports = __webpack_public_path__ + "static/media/samujjwal.3e4b831f.jpg";